import styles from './styles.module.css';
export const TrustedComments = ({ trustedItems }: { trustedItems: any[] }) => {
  return (
    <div className={styles.trustedSection}>
        <div className={styles.trustedInner}>
          <h2 className={styles.trustedTitle + ' text-primary'}>Ils nous ont fait confiance</h2>
          <div className={styles.trustedList}>
            {trustedItems.map((item) => (
              <div className={styles.trustedCard}>
                <div className={styles.trustedAvatar + ' bg-primary'}>
                  <span className={styles.trustedRate}>
                    {item.rate}
                  </span>
                </div>
                <div className={styles.trustedContent}>
                  <span className="text-sm">{item.vehicule}</span>
                  {/* <span className="text-sm">{item.posted_at}</span> */}
                  <span className="text-sm">{item.review}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
  )
}
